import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const userBaseEndpoint = ENDPOINTS.USER;

// Daily Orders API
export const customerApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["customers"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCustomers: builder.query({
        query: ({ page = 1, per_page = 10, search = "" } = {}) => ({
          url: `${userBaseEndpoint}customer`,
          params: {
            page,
            per_page,
            ...(search && { search }),
          },
        }),
        transformResponse: (response) => response,
        providesTags: () => [{ type: "customers" }],
      }),
      getCustomerOrderById: builder.query({
        query: (payload) => `${userBaseEndpoint}customer-order/${payload}`,
        transformResponse: (response) => {
          return response?.data || response;
        },
      }),
      getAllCustomers: builder.query({
        query: () => `${userBaseEndpoint}customer-dropdown`,
        transformResponse: (response) => response,
        providesTags: () => [{ type: "customers" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      addCustomer: builder.mutation({
        query: (requestData) => ({
          url: `${userBaseEndpoint}add-customer`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "customers" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetCustomersQuery,
  useGetAllCustomersQuery,
  useGetCustomerOrderByIdQuery,
  useAddCustomerMutation,
} = customerApi;
